import { useContext, useEffect, useState } from "react";
import { Layout } from "../../../../containers/app/layout";
import {
  PayrollreportFilterCard,
  PayrollreportTableCard,
  PayrollreportWrapper,
} from "./styled";
import { Row } from "../../../../components/flex/styled";
import { BaseFieldSet } from "../../../../components/form/fieldset/styled";
import { BaseSelect } from "../../../../components/form/select/styled";
import { Table } from "../../../../components/table";
import { retrievePayrolls } from "../../../../utils/apis/report/retrievePayrolls";
import { retrievePayrollReport } from "../../../../utils/apis/report/retrievePayrollReport";
import { remitPayrollService } from "../../../../utils/apis/payroll/remitPayroll";
import Cookies from "universal-cookie";
import { getYearRange } from "../../../../helpers/retrieveAllYearsToDate";
import { months } from "../../../../helpers/retrieveAllMonths";
import { getCompanyDetails } from "../../../../utils/apis/company/getCompanyDetails";
import { Context } from "../../../../context";
import { PaymentModal } from "../../../../containers/app/modals/paymentmodal";
import { Label, P, Span } from "../../../../components/typography/styled";
import { downloadPayrollReport } from "../../../../utils/apis/report/downloadPayrollReport";
import { BaseButton } from "../../../../components/button/styled";
import { DotLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { SuccessModal } from "../../../../containers/app/modals/successmodal";

export const PayrollReport = () => {
  const startDate = 2020;
  const endDate = new Date().getFullYear();

  const currentDate = new Date();
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");
  const COMPANY_ID = cookies.get("COMPANY_ID");
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const [filter, setFilter] = useState({
    endYear: currentYear,
    endMonth: currentMonth,
    startYear: currentYear - 1,
    startMonth: currentMonth - 1,
  });
  const [error, setError] = useState(null);
  const [tableerror, setTableError] = useState(null);
  const [payrolls, setPayrolls] = useState([]);
  const [payrollReport, setPayrollReport] = useState([]);
  const [company, setCompany] = useState({});
  const [matches, setMatches] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTableIds, setActiveTableIds] = useState([]);
  const [allIds, setAllIds] = useState([]);
  const [allIdsSize, setAllIdsSize] = useState(0);
  const [remittingPayrollId, setRemittingPayrollId] = useState(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const { setIsPaymentFormModalOpen } = useContext(Context);

  useEffect(() => {
    if (
      !COMPANY_ID ||
      !filter.endMonth ||
      !filter.endYear ||
      !filter.startMonth ||
      !filter.startYear
    )
      return setError(
        "Please select filter. If error persists, contact support.",
      );
    const fetchPayrolls = async () => {
      setError(null);
      setPayrollReport([]);
      setActiveTableIds([]);
      setAllIds([]);
      setAllIdsSize(0);
      try {
        const res = await retrievePayrolls(TOKEN, COMPANY_ID, filter);
        return setPayrolls(res?.data);
      } catch (err) {
        setError(err.message);
        console.error("Failed to fetch payroll report:", err);
      }
    };
    fetchPayrolls();
  }, [TOKEN, COMPANY_ID, filter]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const res = await getCompanyDetails(TOKEN, COMPANY_ID);
        return setCompany(res?.data);
      } catch (err) {
        console.error("Failed to fetch company details:", err);
      }
    };
    fetchCompanyDetails();
  }, [TOKEN, COMPANY_ID]);

  useEffect(() => {
    const handleResize = () => {
      setMatches(window.screen.availWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchPayrollReport = async (payrollId) => {
    setTableError(null);
    try {
      const res = await retrievePayrollReport(TOKEN, COMPANY_ID, payrollId);
      // upsert into payrollReport list
      setPayrollReport((prev) => {
        const others = prev.filter((r) => r.id !== payrollId);
        return [...others, { id: payrollId, data: res?.data }];
      });
      return res?.data;
    } catch (err) {
      setTableError(err.message);
      console.error("Failed to fetch payroll report:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenCreditPurchaseModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPaymentFormModalOpen(true);
  };

  const handleExportTable = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const blob = await downloadPayrollReport(TOKEN, COMPANY_ID, allIds);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // may have to come back to reset this filename
      a.download = "payrollreport.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); // Clean up
      setIsLoading(false);
      console.log("Successfully exported to an xlsx file");
    } catch (error) {
      setIsLoading(false);
      console.error("Failed to export:", error);
    }
  };

  const handleRemitPayroll = async (payrollId) => {
    console.log("Remitting payroll with ID:", payrollId);
    if (!payrollId) return;
    setError(null);
    setRemittingPayrollId(payrollId);
    try {
      const response = await remitPayrollService(TOKEN, COMPANY_ID, payrollId);
      if (response.status === "Success") {
        setIsSuccessModalOpen(true);
      } else {
        setError("Payroll failed to remit.");
        console.error("Payroll failed to remit.");
      }
    } catch (error) {
      setError(`Payroll failed to remit. ${error.message}`);
      console.error("Payroll failed to remit:", error);
    } finally {
      setRemittingPayrollId(null);
    }
  };

  const turnOnView = (id) => {
    setActiveTableIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    setAllIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    setAllIdsSize((prev) => prev + 1);
    fetchPayrollReport(id);
  };

  const turnOffView = (id) => {
    if (activeTableIds.includes(id)) {
      setAllIds((prev) => prev.filter((itemId) => itemId !== id));
      setAllIdsSize((prev) => prev - 1);
      setActiveTableIds((prev) => prev.filter((itemId) => itemId !== id));
      // remove only the report for this id
      setPayrollReport((prev) => prev.filter((r) => r.id !== id));
    }
  };

  return (
    <Layout
      id={"payrollreport"}
      title={"Payroll Report"}
      location={"payroll-report"}
      style={{ textColor: "var(--color-primary)" }}
      callToAction={`CREDIT BALANCE: ${company?.creditBalance}`}
      handleCallToActionClick={handleOpenCreditPurchaseModal}
    >
      <PayrollreportWrapper>
        <SuccessModal
          open={isSuccessModalOpen}
          handleClickOutside={() => setIsSuccessModalOpen(false)}
          className={"remit-payroll-success-modal"}
          title={"Success"}
          message={"Payroll has been successfully remitted"}
          callToAction={"Close"}
          handleCallToActionClick={() => setIsSuccessModalOpen(false)}
        />
        {error && (
          <div className="error-box">
            <P style={{ color: "red" }}>{error}</P>
          </div>
        )}
        <PayrollreportFilterCard aria-label="Payroll Report filters">
          <p className="filter-title">
            <FontAwesomeIcon icon={faFilter} />
            Advanced Filters
          </p>
          <Row className="filter">
            <BaseFieldSet>
              <Label>Start Year</Label>
              <BaseSelect
                name="startYear"
                onChange={handleChange}
                value={filter.startYear}
              >
                {getYearRange(startDate, endDate).map((year, index) => {
                  return (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
            <BaseFieldSet>
              <Label>Start Month</Label>
              <BaseSelect
                name="startMonth"
                onChange={handleChange}
                value={filter.startMonth}
              >
                {months.map((month, index) => {
                  return (
                    <option key={index} value={index + 1}>
                      {month}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
            <BaseFieldSet>
              <Label>End Year</Label>
              <BaseSelect
                name="endYear"
                onChange={handleChange}
                value={filter.endYear}
              >
                {getYearRange(startDate, endDate).map((year, index) => {
                  return (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
            <BaseFieldSet>
              <Label>End Month</Label>
              <BaseSelect
                name="endMonth"
                onChange={handleChange}
                value={filter.endMonth}
              >
                {months.map((month, index) => {
                  return (
                    <option key={index} value={index + 1}>
                      {month}
                    </option>
                  );
                })}
              </BaseSelect>
            </BaseFieldSet>
            <div className="export-button-area">
              <div style={{ overflow: "hidden" }}>
                <BaseButton
                  type="button"
                  className="export-table-btn"
                  width={matches ? "-webkit-fill-available" : "fit-content"}
                  onClick={handleExportTable}
                >
                  {isLoading ? (
                    <DotLoader size={20} color="white" className="dotLoader" />
                  ) : (
                    <Span>Export Table ({allIdsSize})</Span>
                  )}
                </BaseButton>
              </div>
            </div>
          </Row>
        </PayrollreportFilterCard>

        <PayrollreportTableCard>
          {payrolls.map((payroll) => {
            const reportEntry = payrollReport.find(
              (r) => r.id === payroll.payrollId,
            );
            const isOpen = activeTableIds.includes(payroll.payrollId);

            return (
              <section
                key={payroll.payrollId}
                className={`payrollreport-accordion ${isOpen ? "is-open" : ""}`}
              >
                <button
                  type="button"
                  className="payrollreport-accordion-trigger"
                  aria-expanded={isOpen}
                  onClick={() =>
                    isOpen
                      ? turnOffView(payroll.payrollId)
                      : turnOnView(payroll.payrollId)
                  }
                >
                  <span className="payrollreport-accordion-title">
                    <span>Payroll Report</span>
                    <span className="payrollreport-accordion-date">
                      {payroll.dateCreated}
                    </span>
                  </span>
                  <span className="payrollreport-accordion-action">
                    {isOpen ? "Hide report" : "View report"}
                    <span aria-hidden="true" className="payrollreport-chevron">
                      {isOpen ? "−" : "+"}
                    </span>
                  </span>
                </button>
                {isOpen && (
                  <div className="payrollreport-accordion-panel">
                    {tableerror && (
                      <div className="error-box">
                        <P style={{ color: "red" }}>{tableerror}</P>
                      </div>
                    )}
                    <div className="payrollreport-table">
                      <Table
                        columnTitles={[
                          "Employee",
                          "Total Earnings",
                          "Total Deductions",
                          "Gross Pay",
                          "Net Pay",
                          "Action",
                        ]}
                        rowItems={reportEntry?.data?.employees || []}
                        location={"Payroll Report Table"}
                      />
                    </div>
                    <div className="payrollreport-summary">
                      <Span className="summary-item">
                        Total Gross Pay: {reportEntry?.data?.totalGrossPay || 0}
                      </Span>
                      <Span className="summary-item">
                        Total Deductions:{" "}
                        {reportEntry?.data?.totalDeductions || 0}
                      </Span>
                      <Span className="summary-item">
                        Total Net Pay: {reportEntry?.data?.totalNetPay || 0}
                      </Span>
                    </div>
                    <div className="payrollreport-button-area">
                      <BaseButton
                        disabled={remittingPayrollId === payroll.payrollId}
                        onClick={() => handleRemitPayroll(payroll.payrollId)}
                        className="remit-payroll-btn"
                      >
                        {remittingPayrollId === payroll.payrollId ? (
                          <DotLoader
                            size={20}
                            color="white"
                            className="dotLoader"
                          />
                        ) : (
                          <Span>Remit Payroll</Span>
                        )}
                      </BaseButton>
                    </div>
                  </div>
                )}
              </section>
            );
          })}
        </PayrollreportTableCard>
        <PaymentModal />
      </PayrollreportWrapper>
    </Layout>
  );
};
